import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useCookies } from '../../contexts/CookieContext';
import CookieSettings from './CookieSettings';
import './CookieBanner.css';

const CookieBanner = () => {
  const { cookiesAccepted, acceptAllCookies, openCookieSettings } = useCookies();
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    // Mostrar el banner después de un pequeño retraso si no se han aceptado las cookies
    const timer = setTimeout(() => {
      if (!cookiesAccepted) {
        setIsVisible(true);
      }
    }, 1500);
    
    return () => clearTimeout(timer);
  }, [cookiesAccepted]);
  
  // Si las cookies ya han sido aceptadas, no mostrar el banner
  if (cookiesAccepted || !isVisible) {
    return null;
  }
  
  return (
    <>
      <div className="cookie-banner">
        <div className="cookie-content">
          <div className="cookie-header">
            <h3>Tu privacidad es importante</h3>
            <div className="cookie-icon">🍪</div>
          </div>
          
          <p>Utilizamos cookies para mejorar tu experiencia, personalizar contenido y analizar el tráfico. 
            Puedes aceptar todas las cookies o configurar tus preferencias.</p>
          
          <div className="cookie-link">
            <Link to="/cookies">Más información sobre cookies</Link>
          </div>
          
          <div className="cookie-buttons">
            <button 
              className="cookie-config-button"
              onClick={openCookieSettings}
            >
              Configurar
            </button>
            
            <button 
              className="cookie-accept-button"
              onClick={acceptAllCookies}
            >
              Aceptar todas
            </button>
          </div>
        </div>
      </div>
      
      <CookieSettings />
    </>
  );
};

export default CookieBanner;
